import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './FormError.module.scss';
import errorMessages from '../../helpers/errorMessageHelper/errorMessageHelper';
import TestIds from '../../tests/TestIds';

interface Props {
	className?: string;
	isHeadingVisible?: boolean;
	message?: string;
}

const FormError = ({ className, message, isHeadingVisible = true }: Props) => {
	return (
		<div className={classNames(styles.error, className)} data-cy={TestIds.FormError}>
			{message ? (
				<>
					{isHeadingVisible && (
						<span className={styles.heading}>
							<FormattedMessage {...errorMessages.someErrors} />
						</span>
					)}
					{message}
				</>
			) : (
				<FormattedMessage {...errorMessages.genericError} />
			)}
		</div>
	);
};

export default FormError;
